/* eslint-disable sort-keys-fix/sort-keys-fix */
export const SCREEN_SIZE = {
  MOBILE_WIDTH: '500px',
  TABLET_WIDTH: '768px',
  DESKTOP_WIDTH: '1080px',
  LARGE_DESKTOP_WIDTH: '1920px',
  KIOSK_HEIGHT: '1920px',
  KIOSK_WIDTH: '1080px',
} as const;

export const MEDIA = {
  kiosk: `(max-width: ${SCREEN_SIZE.KIOSK_WIDTH})`,
  tablet: `(max-width: ${SCREEN_SIZE.TABLET_WIDTH})`,
  mobile: `(max-width: ${SCREEN_SIZE.MOBILE_WIDTH})`,
  desktop: `(max-width: ${SCREEN_SIZE.DESKTOP_WIDTH})`,
  largeDesktop: `(max-width: ${SCREEN_SIZE.LARGE_DESKTOP_WIDTH})`,
} as const;
